import { ref } from '@vue/composition-api'
import  store  from '@/store'

export default function utilityStore() {

  const loading = ref(false)
  const errors = ref({})

  const blank_data = {
    type: 'utility',
    name: '',
    camp_id: null,
    device_id: null,
    camp_leave: '',
    camp_back: '',
    utilities: [{
      id: 1,
      area: null,
      count: null
    }],
  }

  const form = ref(Object.assign({}, blank_data))

  const fetchPlan = id => {
    store.dispatch('plans/fetchPlan', id).then(r => {
      Object.assign(form.value, r.data.plan, {
        utilities: r.data.plan.data.utilities
      })
      delete form.value.data
    })
  }

  const submit = () =>
     new Promise((resolve, reject) => {
       loading.value = true
       errors.value = {}

      store.dispatch('plans/createPlan', form.value)
        .then(r => {
          Object.assign(form.value, blank_data, {
            utilities: [{
              id: 1,
              area: null,
              count: null
            }],
          })

          resolve(true)
        }).catch(reason => {
          if (reason.response.status === 422)
            errors.value = reason.response.data.errors
        reject(reason.response.data.message)
      }).finally(() => loading.value = false)
    })




  const update = () => new Promise((resolve, reject) => {
    loading.value = true
    errors.value = {}

    store.dispatch('plans/updatePlan', form.value).then(r => resolve(true))
      .catch(reason => {
        if (reason.response.status === 422)
          errors.value = reason.response.data.errors
        reject(reason.response.data.message)
      })
      .finally(() => loading.value = false)
  })


  return {
    loading,
    errors,
    form,
    submit,update,
    fetchPlan
  }
}
